import React, {Component} from 'react';

class SimpleSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {value: props.value};
    }

    onChange(e) {
        const value = e.target.value;
        this.setState({value});
        this.props.onChange(value);
    }

    getOptionTestId(value) {
        const {options, optionTestId, optionTestIdAppend, testId} = this.props;
        const append = '-' + (optionTestIdAppend || 'option');

        if (!testId) return;

        if (optionTestId) {
            return optionTestId.replaceAll('{value}', value);
        }

        return options[value].toString().toLowerCase().replaceAll(' ', '-') + append;
    }

    render() {
        const {className = '', options, testId} = this.props;

        return (
            <select
                onChange={(e) => this.onChange(e)}
                value={this.state.value}
                className={`form-control ${className}`}
                {...(testId && {'data-testid': testId})}
            >
                {Object.keys(options).map((key) => (
                    <option key={key} value={key} data-testid={this.getOptionTestId(key)}>
                        {options[key]}
                    </option>
                ))}
            </select>
        );
    }
}

export default SimpleSelect;
